<template>
  <InputRow v-slot="{ validation: { valid } }" name="creatorFilter" :model-value="selectedIds">
    <LISASelect
      v-model="selectedIds"
      class="w-100"
      hide-label
      multiple
      selection-display="chips"
      :invalid="valid === false"
      :options="selectOptions"
    />
  </InputRow>
</template>

<script setup lang="ts">
import InputRow from "@/components/shared/form/InputRow.vue";
import { computed, inject, onMounted, ref, watch } from "vue";
import { LISASelect, type LISASelectOption } from "@fi-solutions/lisa-ui";
import CreatorFilter from "../filterImplementations/CreatorFilter";
import { BoardFilterOptionsInjectionKey, FilterEntity, FilterUIProps } from "../FilterTypes";

const props = defineProps(FilterUIProps);

const selectedIds = ref<number[]>([]);
const boardFilterOptions = inject(BoardFilterOptionsInjectionKey);
const options = computed(() =>
  props.mode === FilterEntity.EVENT
    ? (boardFilterOptions?.options.value.eventUsers ?? [])
    : (boardFilterOptions?.options.value.actionUsers ?? []),
);
const selectOptions = computed<LISASelectOption[]>(() =>
  options.value.map((option) => ({ id: option.id, label: option.displayName })),
);

async function loadOptions() {
  await boardFilterOptions?.load();
}

onMounted(loadOptions);
watch(() => boardFilterOptions?.queryKey.value, loadOptions);

function getFilter() {
  return selectedIds.value.length === 0 ? null : new CreatorFilter(selectedIds.value);
}
function applyFilter(filter: CreatorFilter) {
  selectedIds.value = filter.userIds;
}

defineExpose({ getFilter, applyFilter });
</script>

<style lang="scss" scoped></style>
